import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import TextAreaField from "../../Forms/Input/TextAreaField";

interface VerificationErrorBoxProps {
  message: string;
}

/**
 * ⚠️ VerificationErrorBox
 * Muestra un mensaje de error detallado cuando ocurre un fallo
 * en la verificación de una firma digital.
 */
const VerificationErrorBox: React.FC<VerificationErrorBoxProps> = ({ message }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mt-8 w-full rounded-xl border border-[#DC3545] bg-[#FEECEC] p-6 shadow-md dark:border-red-800 dark:bg-red-900/20"
    >
      {/* 🔹 Encabezado */}
      <div className="mb-4 flex items-center gap-2">
        <AlertTriangle className="h-6 w-6 text-[#DC3545] dark:text-red-400" />
        <h3 className="text-lg font-semibold text-[#DC3545] dark:text-red-400">
          Error en la Verificación de Firma
        </h3>
      </div>

      {/* 🔹 Detalle del error */}
      <TextAreaField
        label="Detalle del error"
        name="verificationError"
        value={message}
        onChange={() => {}}
        rows={4}
        disabled
        iconKey="alert-circle"
      />

      <p className="mt-2 text-xs italic text-[#DC3545]/80 dark:text-red-400/70">
        ⚠️ Verifica que la firma Base64 sea correcta y que el payload no haya sido modificado.
      </p>
    </motion.div>
  );
};

export default VerificationErrorBox;
